$(document).ready(function () {
  $(document).on('click', '.clients-momentum-planning-post-cday-component .radio-buttons__option', function () {
    const component = $(this).closest('.clients-momentum-planning-post-cday-component'); // Update yes-no radio button values back to section
    const id = component.attr('momentum_cday_post_section_id'); // Id of the section
    const property = $(this).attr('attr'); // Which radio is getting clicked
    const value = $(this).attr('value'); // Value of the radio button

    if (property === 'non_funded_units') {
      $('.post-cday-non-funded-units-js').toggle(value === '1');
    }

    updateCDaySection(id, property, value);
  });

  $(document).on('change', '.date-picker-js input', function () {
    const component = $(this).closest('.clients-momentum-planning-post-cday-component'); // Assuming component has relevant section data
    const id = component.attr('momentum_cday_post_section_id'); // Get the section ID
    const property = $(this).attr('name');
    const value = $(this).val(); // Get the new date value

    updateCDaySection(id, property, value); // Call the update function
  });

  // UPDATE TEXT INPUT VALUES
  $(document).on('keyup', '.clients-momentum-planning-post-cday-component .input-text-box-js input', function () {
    const component = $(this).closest('.clients-momentum-planning-post-cday-component');
    const id = component.attr('momentum_cday_post_section_id');
    const property = $(this).attr('attr');
    const value = $(this).val();

    // Clear any existing timeout
    clearTimeout($(this).data('timeout'));

    // Set a timeout to update the value after 2 seconds
    $(this).data('timeout', setTimeout(function () {
      updateCDaySection(id, property, value);
    }, 1000));
  });

  // UPDATE TEXT AREA VALUES
  $(document).on('keyup', '.clients-momentum-planning-post-cday-component .text-area-js textarea', function () {
    const component = $(this).closest('.clients-momentum-planning-post-cday-component');
    const id = component.attr('momentum_cday_post_section_id');
    const property = $(this).attr('attr');
    const value = $(this).val();

    // Clear any existing timeout
    clearTimeout($(this).data('timeout'));

    // Set a timeout to update the value after 2 seconds
    $(this).data('timeout', setTimeout(function () {
      updateCDaySection(id, property, value);
    }, 1000));
  });

  function updateCDaySection(id, property, value) {
    $.post('/components/clients/momentum_sections/post_cday', {
      id: id,
      property: property,
      value: value
    }).done(function (data) {

      if (data.success) {
        window.reloadConfirmationDayReadinessAssessmentComponent();
        window.reloadMomentumSectionPlanningTab(data.section_completion_percentage, 'post_cday');
        window.reloadClientTaskBinComponents();
      }
    });
  }
});
